interface LogoProps {
  className?: string;
  withText?: boolean;
  textClassName?: string;
  size?: number;
}

function LogoImg({ size, className = '' }: { size: number; className?: string }) {
  return (
    <picture>
      <source
        type="image/webp"
        srcSet="/logo-72.webp 1x, /logo-144.webp 2x, /logo-256.webp 3x"
      />
      <img
        src="/logo-144.webp"
        alt="CampanhaFlow"
        width={size}
        height={size}
        className={className}
        loading="eager"
        decoding="async"
        fetchPriority="high"
      />
    </picture>
  );
}

export function Logo({
  className = '',
  withText = false,
  textClassName = '',
  size = 40,
}: LogoProps) {
  return (
    <div className={`inline-flex items-center gap-2.5 ${className}`}>
      <LogoImg size={size} className="flex-shrink-0 rounded-lg" />

      {withText && (
        <span
          className={`font-display text-xl font-bold text-ink-900 tracking-tight ${textClassName}`}
        >
          CampanhaFlow
        </span>
      )}
    </div>
  );
}

export function LogoMark({ className = '', size = 40 }: { className?: string; size?: number }) {
  return <LogoImg size={size} className={`rounded-lg ${className}`} />;
}
